import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { StateSnackBarService } from '../../../services/state-snack-bar.service';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatButton,
    MatIcon,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatIconButton,
    MatCardSubtitle,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private router = inject(Router);
  private snackBar = inject(StateSnackBarService);

  token: string | null = null;
  passwordControl = new FormControl('', [Validators.required, Validators.minLength(6)]);
  message: string | null = null;
  hidePassword = true;

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (!this.token) {
      this.message = 'Fehler: Ungültiger oder fehlender Token.';
    }
  }

  resetPassword(): void {
    if (this.passwordControl.invalid || !this.token) return;
    const newPassword = this.passwordControl.value!;

    this.authService.resetPassword(this.token, newPassword).subscribe({
      next: (response) => {
        this.snackBar.success({ message: response.message });
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.message = err.error.message || 'Ein unbekannter Fehler ist aufgetreten.';
      },
    });
  }
}
